<p-panel [toggleable]="true" [collapsed]="shouldBeCollapsed">
  <ng-template #header
    ><div>
      <i class="fa-solid fa-toggle-on mr-3"></i>Digital Outputs (On the board
      itself)
    </div></ng-template
  >
  <p-table
    showGridlines="true"
    stripedRows
    size="small"
    [loading]="isLoading()"
    [value]="tableRowsSmall()"
    [columns]="headersSmall()"
    class="lg:hidden"
  >
    <ng-template #header let-columns>
      <tr>
        <th></th>
        @for(header of columns; track idx; let idx = $index) {
        <th>
          <div class="text-center">{{ header }}</div>
        </th>
        }
      </tr>
    </ng-template>
    <ng-template #body let-row let-rowIndex="rowIndex">
      <tr>
        <td>
          <div class="text-center">Out {{ rowIndex + 1 }}</div>
        </td>
        <td>
          <div class="text-center">
            <i
              class="text-xl mt-1"
              [class]="
                row.value ? 'fa-solid fa-toggle-on' : 'fa-solid fa-toggle-off'
              "
            ></i>
          </div>
        </td>
        <td>
          <div class="text-center">
            <i
              [class]="iconsStyles.getActiveIcon(row.controllable)"
              [style]="iconsStyles.getActiveStyle(row.controllable)"
            ></i>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <p-table
    showGridlines="true"
    stripedRows
    size="small"
    [loading]="isLoading()"
    [value]="tableRows()"
    class="hidden lg:inline"
  >
    <ng-template #header>
      <tr>
        @for(col of [].constructor(ioInformation().amountOfOutputs + 1); track
        idx; let idx = $index) { @if(idx === 0){
        <th class="lg:w-1/10 xl:w-1/12 2xl:w-1/14 3xl:w-1/16"></th>
        } @else {
        <th>
          <div class="text-center">Output {{ idx }}</div>
        </th>
        } }
      </tr>
    </ng-template>
    <ng-template #body let-row let-rowIndex="rowIndex">
      <tr>
        <td>
          <div class="text-center">{{ row }}</div>
        </td>
        @if(rowIndex === 0) { @for(controllable of controllableValues(); track
        idx; let idx = $index){
        <td>
          <div class="text-center">
            <i
              [class]="iconsStyles.getActiveIcon(controllable)"
              [style]="iconsStyles.getActiveStyle(controllable)"
            ></i>
          </div>
        </td>
        } } @if(rowIndex === 1) { @for(value of outputValues(); track idx; let
        idx = $index){
        <td>
          <div class="text-center">
            <i
              class="text-xl mt-1"
              [class]="
                value ? 'fa-solid fa-toggle-on' : 'fa-solid fa-toggle-off'
              "
            ></i>
          </div>
        </td>
        } }
      </tr>
    </ng-template>
  </p-table>
</p-panel>
